module.exports = __webpack_public_path__ + "img/Basico.3ce5238b.png";